import { createSelector } from '@ngrx/store';
import { selectUrl } from 'src/app/store/router/selectors';

export const isAuditsPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/audits(\/|$)/i));

export const isAdminPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/admin(\/|$)/i));

export const isAuditingPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/auditing(\/|$)/i));

export const isDailyAuditPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/admin\/publish\/(daily|monthly)-reports\/.+/i));

export const isReportsPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/reports(\/|$)/i));

export const isPreviewPageSelector = createSelector(selectUrl, (url: string | undefined) => !!url?.match(/^\/preview(\/|$)/i));
